import { render, staticRenderFns } from "./ns-pos-confirm-popup.vue?vue&type=template&id=34356369&"
import script from "./ns-pos-confirm-popup.vue?vue&type=script&lang=js&"
export * from "./ns-pos-confirm-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports